module.exports = __webpack_public_path__ + "img/Img2.ec59abae.jpg";